<template>
    <div class="home-content">
        <div class="hint-text">还未绑定设备，请点击下面按钮扫码绑定设备：</div>
        <div class="operate-button-wrapper">
            <button class="operate-button" @click="handleBindingDevice">绑定设备</button>
        </div>
    </div>
</template>

<script>
    import {APP_ID} from "@/config";
    import wx from 'weixin-js-sdk';

    export default {
        name: "BindingDeviceHome",
        methods: {
            handleBindingDevice() {
                const self = this;
                wx.ready(function (){
                    wx.scanQRCode({
                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                        success: function (res) {
                            let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                            if (result.indexOf('https://wx.mingzr.com') >= 0) {
                                self.$router.replace(result.replace('https://wx.mingzr.com',''));
                            }
                        }
                    });
                });
            },

            async loadTicketConfig() {
                try {
                    let {data} = await this.$req.getTicketConfig({
                        url:  window.location.href
                    });
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: APP_ID, // 必填，公众号的唯一标识
                        timestamp: data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.nonceStr, // 必填，生成签名的随机串
                        signature: data.signature,// 必填，签名
                        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
                    });
                } catch (e) {
                    //TODO
                }
            }
        },
        mounted() {
            this.loadTicketConfig();
        }
    }
</script>